const PayWithPesoStatus = {
  Success: "success",
  Pending: "pending",
  Failed: "failed",
  Voided: "voided",
};

export default PayWithPesoStatus;
